import { ProcedureId } from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'
import { ConcatenatedBatches } from '@/Domain/AuctionA'
import { ApiClient } from '@/Domain/ApiClient'
import {
  EncryptedXmlOffer,
  EncryptedXmlOfferRepository,
  EncryptedXmlOfferRepositoryError,
  EncryptedXmlOfferSerializer
} from '@/Domain/XmlOffer/Encrypter'
import { EncryptedXmlOfferJsonData } from './EncryptedXmlOfferJsonData'

export class AxiosEncryptedXmlOfferRepository implements EncryptedXmlOfferRepository {
  private _apiClient: ApiClient
  private _serializer: EncryptedXmlOfferSerializer<EncryptedXmlOfferJsonData>

  constructor (
    apiClient: ApiClient,
    serializer: EncryptedXmlOfferSerializer<EncryptedXmlOfferJsonData>
  ) {
    this._apiClient = apiClient
    this._serializer = serializer
  }

  async store (
    procedureId: ProcedureId,
    userId: AccountId,
    concatenatedBatches: ConcatenatedBatches,
    encryptedXmlOffers: EncryptedXmlOffer[]
  ): Promise<string> {
    try {
      const url = '/sobree/api/sobreb/update'
      const responseUrl = await this._apiClient.makePostRequest(
        url,
        {
          procedureId: procedureId.id,
          userId: userId.accountId(),
          batches: concatenatedBatches.value(),
          encryptedOffers: this.serializeOffers(encryptedXmlOffers)
        }
      )
      return responseUrl.data.data.data
    } catch (error) {
      return Promise.reject(new EncryptedXmlOfferRepositoryError(error.message))
    }
  }

  private serializeOffers (encryptedXmlOffers: EncryptedXmlOffer[]): EncryptedXmlOfferJsonData[] {
    const offers: EncryptedXmlOfferJsonData[] = []
    for (const offer of encryptedXmlOffers) {
      offers.push(this._serializer.serialize(offer))
    }
    return offers
  }
}
